import { NgFor, NgIf } from '@angular/common';
import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { CreateAiAgentDialogComponent } from '../create-ai-agent-dialog/create-ai-agent-dialog.component';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { AiAgentService } from '../../../services/ai-agent.service';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { variablePathNames } from '../../../utilities/routing-path-utils';


@Component({
  selector: 'app-assistants-list',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormField,
    MatInput,
    MatIcon,
    MatLabel,
    MatPrefix,
    NgFor,
    MatButtonModule,
    NgIf,
    MatProgressSpinnerModule
  ],
  templateUrl: './assistants-list.component.html',
  styleUrl: './assistants-list.component.scss'
})
export class AssistantsListComponent {
  filteredAgents: AiAgentResponse[] = [];
  aiAgents!: AiAgentResponse[];
  isLoading: boolean = false;
  subaccountId: number | undefined = undefined;

  constructor(
    private aiConfigurationPageEvents: AiConfigurationPageEventsService,
    private dialog: MatDialog,
    private aiAgentService: AiAgentService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.fetchAiAgents();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredAgents = this.aiAgents;

    this.filteredAgents = this.aiAgents.filter(agent => agent.name.toLowerCase().includes(filterValue.toLowerCase()))
  }

  onCreateAssistant() {
    this.dialog.open(CreateAiAgentDialogComponent, {
      width: '25%',
      data: { subaccountId: this.subaccountId }
    });
  }

  onEditAssistant(aiAgent: AiAgentResponse) {
    this.aiConfigurationPageEvents.onEditAssistantEvent.emit(aiAgent);
  }

  fetchAiAgents() {
    this.route.paramMap.subscribe(params => {
      const userIdPathVar = params.get(variablePathNames.subaccountUserIdPathVariable) || undefined;
      if (userIdPathVar) {
        const userId = parseInt(userIdPathVar);
        
        if (!isNaN(userId)) {
          this.subaccountId = userId;
          this.fetchSubaccountAiAgents(userId);
        } else {
          this.fetchLoggedUserAiAgents(); //TODO show error message over here
        }
      } else {
        this.fetchLoggedUserAiAgents();
      }
    });
  }

  fetchSubaccountAiAgents(userId: number) {
    this.isLoading = true;
    
    this.aiAgentService.fetchSubaccountAiAgents(userId).subscribe({
      next: (aiAgents) => {
        this.setAiAgents(aiAgents);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert('Server Error, contact support');
      }
    });
  }

  fetchLoggedUserAiAgents() {
    this.isLoading = true;

    this.aiAgentService.fetchLoggedUserAiAgents().subscribe({
      next: (aiAgents) => {
        this.setAiAgents(aiAgents);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert('Server Error, contact support');
      }
    });
  }

  capitalizeFirstLetter(string:string) {
    if(string){
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();  
    }
    return "";
  }

  setAiAgents(aiAgents: AiAgentResponse[]) {
    this.aiAgents = aiAgents;
    this.filteredAgents = this.aiAgents;
  }
}
